module.exports = __webpack_public_path__ + "static/media/base.d4d9d415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/TradeCryptoResources/base.svg
// module id = 160
// module chunks = 0